import { useContext } from 'react';
import { BIMContext } from 'providers/bim-provider';
import Images from 'assets/Images';
import { ContentWrapper, Textbox } from 'components/generic';
import './style.scss';
import { cloneDeep } from 'lodash';

const Linkage = () => {
	const context = useContext(BIMContext);
	const { createObj, dockerState, setCreateObj } = context;

	// handle linkage add
	const handleAddLinkage = prevState => {
		const link = prevState?.bfm_linkages;
		setCreateObj(prevState => ({ ...prevState, bfm_linkages: [...link, { p_code: '', bfm_filePath: '' }] }));
	};

	// data handler function to set create obj
	const dataHandler = (el, i, key) => {
		setCreateObj(prevState => {
			const data = cloneDeep(prevState);
			data.bfm_linkages[i][key] = el;
			return data;
		});
	};

	// handle linkage delete function
	const handleLinkageDelete = i => {
		setCreateObj(prevState => {
			const data = cloneDeep(prevState);
			data.bfm_linkages.splice(i, 1);
			return data;
		});
	};

	// each linakge element
	const linkageElement = (data, i) => {
		return (
			<div className='row' key={i}>
				<div className='col-5'>
					<Textbox label={i === 0 ? 'Product' : ''} infoContent='Enter Product' mandatory disabled={dockerState === 'view'} value={data?.p_code} placeholder='Select' onChange={e => dataHandler(e?.target?.value, i, 'p_code')} />
				</div>
				<div className='col-5'>
					<Textbox
						mandatory
						infoContent='Enter File Path'
						label={i === 0 ? 'File Path' : ''}
						disabled={dockerState === 'view'}
						value={data?.bfm_filePath}
						onChange={e => dataHandler(e?.target?.value, i, 'bfm_filePath')}
						placeholder='Eg: D:CxDocStoreDocStorePDFCXSOLBatchUpdateData'
					/>
				</div>
				{i !== 0 && (
					<div className='linkage__delete'>
						<img src={Images.deleteGrey} alt='delete' width='18px' height='18px' onClick={() => handleLinkageDelete(i)} />
					</div>
				)}
			</div>
		);
	};

	// linkage loop data
	const linkageData = createObj?.bfm_linkages?.map((el, i) => linkageElement(el, i));

	return (
		<>
			<ContentWrapper shadow>
				{linkageData}
				<div className='linkage__add' onClick={handleAddLinkage}>
					<img src={Images.add} alt='add' width='25px' height='25px' />
					<span>Add another</span>
				</div>
			</ContentWrapper>
		</>
	);
};

export default Linkage;
